/**
 * Gaston Quick Add
 * Gère l'ajout au panier depuis les vignettes produit :
 * - Produit mono-variant : ajout direct
 * - Produit multi-variants : ouvre le dialog de sélection
 */

async function gastonAddToCart(variantId, buttonEl) {
  if (!variantId) return;

  buttonEl.disabled = true;
  const originalText = buttonEl.textContent;
  buttonEl.textContent = '...';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });

    if (!response.ok) throw new Error('Erreur ajout panier');

    buttonEl.textContent = '✓';
    buttonEl.dataset.added = 'true';

    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { data: { itemCount: cart.item_count } }
    }));

    const dialog = buttonEl.closest('dialog');
    if (dialog) {
      setTimeout(() => dialog.close(), 600);
    }

    setTimeout(() => {
      buttonEl.textContent = originalText;
      delete buttonEl.dataset.added;
      buttonEl.disabled = false;
    }, 1200);

  } catch (err) {
    console.error('[Gaston] Erreur ajout panier:', err);
    buttonEl.textContent = originalText;
    buttonEl.disabled = false;
  }
}

document.addEventListener('click', (event) => {
  const btn = event.target.closest('.gaston-overlay__btn--single, .gaston-variants-dialog__add-btn');
  if (!btn) return;
  event.preventDefault();
  const variantId = btn.dataset.variantId;
  if (variantId) gastonAddToCart(variantId, btn);
});

/**
 * Gaston Carousel CTA
 * Injecte une carte "Voir tous les produits" à la fin du carrousel produits homepage
 */

// CSS de la carte CTA
const ctaStyle = document.createElement('style');
ctaStyle.textContent = `
  .gaston-cta-slide {
    flex-shrink: 0;
    display: flex !important;
    align-items: stretch;
  }
  .gaston-cta-slide__inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    background: #f5f3ee;
    border-radius: 12px;
    border: 1.5px solid rgba(0,0,0,0.12);
    padding: 32px 24px;
    text-decoration: none;
    color: #1c1c1c;
    font-family: var(--font-body--family, sans-serif);
    transition: border-color 0.2s, background 0.2s;
    width: 100%;
    aspect-ratio: 4/5;
    text-align: center;
  }
  .gaston-cta-slide__inner:hover {
    border-color: #1c1c1c;
    background: #ede9e2;
  }
  .gaston-cta-slide__label {
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    line-height: 1.4;
  }
  .gaston-cta-slide__arrow {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 1.5px solid rgba(0,0,0,0.2);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .gaston-cta-slide__arrow svg {
    width: 16px;
    height: 16px;
    stroke: currentColor;
    fill: none;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
`;
document.head.appendChild(ctaStyle);

function gastonInjectCarouselCTA() {
  const section = document.querySelector('#shopify-section-product_carousel_main');
  if (!section) return;
  if (section.querySelector('.gaston-cta-slide')) return;

  // Trouver le conteneur des cartes produit (ul ou ol avec les li produits)
  const candidates = section.querySelectorAll('ul, ol, [class*="product-grid"], [class*="product-list__items"]');
  let container = null;
  for (const el of candidates) {
    if (el.children.length > 0) {
      container = el;
      break;
    }
  }

  // Fallback : chercher le parent commun des card-gallery
  if (!container) {
    const firstCard = section.querySelector('.card-gallery');
    if (firstCard) container = firstCard.closest('ul, ol') || firstCard.parentElement;
  }

  if (!container) return;

  const ctaItem = document.createElement('li');
  ctaItem.className = 'gaston-cta-slide';

  ctaItem.innerHTML = `
    <a href="/collections/all" class="gaston-cta-slide__inner">
      <div class="gaston-cta-slide__label">Voir tous<br>les produits</div>
      <div class="gaston-cta-slide__arrow">
        <svg viewBox="0 0 24 24">
          <line x1="5" y1="12" x2="19" y2="12"/>
          <polyline points="12 5 19 12 12 19"/>
        </svg>
      </div>
    </a>
  `;

  container.appendChild(ctaItem);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => setTimeout(gastonInjectCarouselCTA, 800));
} else {
  setTimeout(gastonInjectCarouselCTA, 800);
}
